module.exports = __webpack_public_path__ + "img/emoji_active.f6b70e81.svg";